<div class="loader-overlay">
    <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
</div>